import React from 'react';

const style = {
  verticalAlign: 'middle',
};

const Template = ({ record, size, width, height }) =>
  <img
    alt="empty"
    src={`${record.gallery[0]}?size=65x115`}
    size={size}
    style={{ ...style, width: `auto`, height: `${height}px`}}
  />;

Template.defaultProps = {
  size: 65,
  width: 115,
  height: 65,
};

const TemplateField = ({ record = {}, width, height, size=65, label, source}) =>
<span>
  {  record.gallery  &&
    record.gallery.length > 0 && <Template record={record} size={size} width={width} height={height} />

  }
  <span style={{ display: 'inline-block', width: size / 3 }}>&nbsp;</span>
  { source && record.name}
</span>;

export default TemplateField;



// WEBPACK FOOTER //
// ./src/pages/custom/imageSize.js